import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'error-history-drawer',
  templateUrl: './error-history.component.html',
  styleUrls: ['./error-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorHistoryComponent {
  @Input() message: string | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onRetry() {
    this.retry.emit();
  }

  getTruncatedMessage(): string {
    if (!this.message) return '';
    const lines = this.message.split('\n');
    if (lines.length <= 3) return this.message;
    return lines.slice(0, 3).join('\n') + '\n...';
  }
}
